import { deleteCookie, setCookie } from 'stash/utils/cookies';
import { generateRandomString } from 'stash/utils/random';
import pkceChallenge from 'pkce-challenge';
import {
    CODE_VERIFIER_COOKIE_NAME,
    STATE_PARAM_COOKIE_NAME,
} from 'stash/constants/cookies';
import { buildAuthRedirectLogin } from 'stash/utils';
import useNudata from 'stash/hooks/nudata';


export default function useGetLoginUrl() {
    const { nudataHasError, nudataQueryParams } = useNudata();
    
    const getLoginUrl = () => {
        const stateParam = generateRandomString();
        const { code_verifier, code_challenge } = pkceChallenge();

        //clear out any existing authv2 state param and set a new one in a cookie
        deleteCookie(STATE_PARAM_COOKIE_NAME);
        setCookie(STATE_PARAM_COOKIE_NAME, stateParam);

        //clear out any existing authv2 code verifier and set a new one in a cookie
        deleteCookie(CODE_VERIFIER_COOKIE_NAME);
        setCookie(CODE_VERIFIER_COOKIE_NAME, code_verifier);

        if (nudataQueryParams || nudataHasError) {
            return buildAuthRedirectLogin(
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                window.Stash.env,
                stateParam,
                code_challenge,
                nudataQueryParams
            );
        }
        return buildAuthRedirectLogin(
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window.Stash.env,
            stateParam,
            code_challenge,
        )
    }
    return {
        getLoginUrl,
    }

}